import {
  Component,
  Renderer2,
  OnInit,
  ElementRef,
  Inject,
} from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { Localization, LocalizationService } from '../../services/localization/localization.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {

  isLogin!: boolean;
  environment = environment;

  constructor(
    private localization: LocalizationService,
    private authService: AuthService) {}

  ngOnInit(): void {
    if (this.authService.IsSignIn()) {
      this.isLogin = true;
    }
  }

  changeLanguage() {
    this.localization.isRtl() ? this.localization.setLang(Localization.English) : this.localization.setLang(Localization.Arabic);
  }
}
